import React, { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";
import { Button } from "@/components/ui/button";

const DISMISS_KEY = "pwa-install-dismissed";

function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY)) return;
    const onBIP = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onBIP);
    const onInstalled = () => { setShow(false); localStorage.setItem(DISMISS_KEY, "1"); };
    window.addEventListener("appinstalled", onInstalled);
    // iOS Safari fires no beforeinstallprompt — show a manual hint instead.
    let t;
    if (isIos()) t = setTimeout(() => { setIosHint(true); setShow(true); }, 2000);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBIP);
      window.removeEventListener("appinstalled", onInstalled);
      if (t) clearTimeout(t);
    };
  }, []);

  const dismiss = () => { setShow(false); localStorage.setItem(DISMISS_KEY, "1"); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch (_) {}
    setDeferred(null); setShow(false); localStorage.setItem(DISMISS_KEY, "1");
  };

  if (!show) return null;

  return (
    <div data-testid="install-banner"
      className="fixed z-50 left-1/2 -translate-x-1/2 bottom-[72px] md:bottom-5 w-[calc(100%-2rem)] max-w-sm">
      <div className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white shadow-lg px-4 py-3 animate-in fade-in slide-in-from-bottom-2 duration-300">
        <div className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center shrink-0">
          <Download className="h-4 w-4 text-white" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-slate-900">PrüfDoc Pro installieren</p>
          {iosHint ? (
            <p className="text-xs text-slate-500">Im Teilen-Menü <Share className="inline h-3 w-3 mx-0.5" /> „Zum Home-Bildschirm“ wählen.</p>
          ) : (
            <p className="text-xs text-slate-500">Als App auf dem Startbildschirm – auch offline nutzbar.</p>
          )}
        </div>
        {!iosHint && (
          <Button size="sm" onClick={install} data-testid="install-accept-btn" className="shrink-0 h-8">
            Installieren
          </Button>
        )}
        <button onClick={dismiss} data-testid="install-dismiss-btn"
          className="shrink-0 p-1 rounded hover:bg-slate-100 text-slate-400" title="Ausblenden">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
